import React from 'react';
import { Link } from '@chakra-ui/react';

import ImpactReportLayout from '../../../../../components/layouts/impactreport';
import TableOfContents from '../../../../../components/sections/tableofcontents';
import ImpactReportPrevNextNav from '../../../../../components/sections/impactreport/prev-next-nav';

import appendicesHeroImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/appendices/appendix_cover.jpg'

// Build the Appendices
import TwentyTwentyFourImpactReportAppendixA from './appendix-a';
import TwentyTwentyFourImpactReportAppendixB from './appendix-b';
import TwentyTwentyFourImpactReportAppendixC from './appendix-c';
import TwentyTwentyFourImpactReportAppendixD from './appendix-d';
import TwentyTwentyFourImpactReportAppendixE from './appendix-e';
import TwentyTwentyFourImpactReportFootnotes from './footnotes';

export default function TwentyTwentyFourImpactReportAppendices() {

    const links = [
        {
            title: "About Us and 2024 Highlights",
            href: "/corporate-responsibility/impact/2024",
            active: false
        },
        {
            title: "Empowering People",
            href: "/corporate-responsibility/impact/2024/empowering-people",
            active: false
        },
        {
            title: "Sustaining Places",
            href: "/corporate-responsibility/impact/2024/sustaining-places",
            active: false
        },
        {
            title: "Responsible Practices",
            href: "/corporate-responsibility/impact/2024/responsible-practices",
            active: false
        },
        {
            title: "Appendices",
            //href: "/corporate-responsibility/impact/2024/appendices",
            active: true
        }
    ];

    const ReportNav = () => {
        return ( 
        <>
            <div>
                <nav id='main-report-nav'>
                    <ul className='nav-list'>
                        {links.map(link => (
                            link.active === false ? (
                            <li key={link.title}>
                                <Link href={link.href} className='nav-link'>
                                    <span className='nav-link__text'>{link.title}</span>
                                </Link>
                            </li>
                            ) :
                            (
                                <li className='active' key={link.title}>
                                    <span className='nav-link__text'>{link.title}</span>
                                    <TableOfContents />
                                </li>
                            )
                        )
                        )}
                    </ul>
                </nav>
            </div>
        </>
        );
      }

      function Hero() {
        return(<>
            <section>
                <div className='hero-main height-100'>
                    <div className='hero-main__container'>
                    <div className='hero-main__inner-container'>
                        <div className='hero-main__inner center-left is-top is-left'>
                        <div className='hero-main__text container'>
                            <div className="hero-main__content" style={{ backgroundColor: 'var(--csc-gray)', borderRadius: '50%', marginLeft: '-120px' }}>
                                <div style={{ aspectRatio: '1 / 1', display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: '60ch', paddingLeft: '8em', paddingRight: 'var(--space-l)', paddingTop: 'var(--space-2xl)', paddingBottom: 'var(--space-2xl)' }}>
                                    <h1 style={{ lineHeight: '1.1', textShadow: 'none' }}>Appendices</h1>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div className='hero-main__video-container'>
                            <img src={appendicesHeroImg} alt='' />
                        </div>
                        <div className='hero-main__overlay'></div>
                    </div>
                    </div>
                </div>
            </section>
        </>)
    }
    
    return (
        <ImpactReportLayout
            reportTitle="2024 CSC Impact Report"
            sidebar={<ReportNav />}
            reporthero={<Hero />}
            pdfUrl="/pdfs/2024-impact-report.pdf"
        >
            <title>2024 Impact Report - Appendices</title>
            <meta name="description" content="Appendices for the 2024 Impact Report, providing additional context and information." />

            <div className='flow'>
                <TwentyTwentyFourImpactReportAppendixA />
            
                <TwentyTwentyFourImpactReportAppendixB />
            
                <TwentyTwentyFourImpactReportAppendixC />
            
                <TwentyTwentyFourImpactReportAppendixD />
            
                <TwentyTwentyFourImpactReportAppendixE />

                 <ImpactReportPrevNextNav
                    prevText="Responsible Practices"
                    prevLink="/corporate-responsibility/impact/2024/responsible-practices"
                />
            
                <TwentyTwentyFourImpactReportFootnotes />
            </div>

           

        </ImpactReportLayout>

        
    );
}
